<template>
  <div class="second_item">
    <div class="second_item_top">
      <div class="top_time">{{data.time}}</div>
      <div class="top_title">{{data.title}}</div>
      <div class="top_delete" @click="toDeleteFun()">删除</div>
      <div class="second_item_delete_pop" v-if="deleteState">
        <div class="title">通知を削除しますか？</div>
        <div class="pop_btn">
          <div class="pop_btn_item" @click="deleteFun()">確認</div>
          <div class="pop_btn_item" @click="toDeleteFun()">キャンセル</div>
        </div>
      </div>
    </div>
    <div class="second_item_content">
      {{data.content}}
    </div>
  </div>
</template>

<script>

export default {
  props:{
    data:{
      type:Object,
      default: null
    }
  },
  components: {
  },
  data () {
    return{
      deleteState: false,
      comment: '',
    }
  },
  created () {
  },
  methods: {
    toDeleteFun(){
      if(this.deleteState){
        this.deleteState = false
      }else{
        this.deleteState = true
      }
    },
    deleteFun(){
      console.log(this.data.id)
    }
  }
}
</script>
<style scoped>
.second_item{
  width: 737px;
  border-radius: 6px;
  margin: 0 auto;
  margin-top: 34px;
  border: 1px solid #ccc;
  padding: 26px 25px 32px 24px;
}
.second_item_top{
  position: relative;
}
.second_item_top div{
  display: inline-block;
  vertical-align: middle;
}
.second_item_top .top_time{
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
}
.second_item_top .top_title{
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 16px;
  margin-left: 32px;
}
.second_item_top .top_delete{
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 16px;
  position: absolute;
  right: 0;
  cursor: pointer;
}
.second_item_content{
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-top: 15px;
}
.second_item_delete_pop{
  width: 172px;
  height: 77px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.1);
  border-radius: 5px;
  position: absolute;
  top: 0px;
  right: 32px;
}
.second_item_delete_pop .title{
  width: 100%;
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  line-height: 14px;
  text-align: center;
  margin-top: 14px;
}
.pop_btn{
  width: 100%;
  margin-top: 14px;
  font-size: 12px;
  font-weight: 300;
  color: #666666;
  text-align: center;
}
.pop_btn_item{
  display: inline-block;
  width: 73px;
  height: 20px;
  line-height: 20px;
  background: #F6F6F6;
  border-radius: 5px;
  margin: 0 auto;
  cursor: pointer;
}
.pop_btn_item:last-child{
  margin-left: 8px;
}
</style>